$(document).ready(function () {
  // filter tab colla
  $("body").on("click", ".facets__summary", function () {
    $(this).closest(".js-filter").find(".facet-filter-list").slideToggle();
  });

  $("body").on("click", "li.facets__item label", function () {
    var url = $(this).attr("data-url");

    //window.location.href = url;
  });

  $(document).on("click", ".c__filters-button", function() {
    $(this).closest(".facets-container").find(".facets").addClass("active");
  });

  $("body").on("click", ".facets__form-close", function (e) {
    e.preventDefault();
    $(this).closest(".facets-container").find(".facets").removeClass("active");
  });
});

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.querySelector('.js-price-filter-apply').addEventListener('click', this.onRangeClick.bind(this));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onRangeClick(event) {
    const currentUrl = window.location.href;
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];

    var updatedUrl = currentUrl + '&' + minInput.getAttribute('name') + '=' + minInput.value + '&' + maxInput.getAttribute('name') + '=' + maxInput.value;
    window.location.href = updatedUrl;
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);